import { TFunction } from 'i18next';
import React, { useMemo } from 'react';

import { ResourceTypeDto, TaskStatusDto } from '@/api/generated';
import { useGetResourceTasks } from '@/api/useGetResourceTasks.util.ts';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { CustomerDetailsAccordion } from '@/views/customerDetails/components/CustomerDetailsAccordion.comp.tsx';
import { ProcessDetailsTasksTableRow } from '@/views/processesDetails/components/tasks/comp/ProcessDetailsTasksTableRow.comp.tsx';
import { TasksListTable } from '@/views/tasks/list/components/table/TasksListTable.comp.tsx';

type Props = {
  contactId: number;
};

const defaultStatusesFn = (t: TFunction): SelectSearchOptionModel<TaskStatusDto>[] => [
  {
    label: t(`taskStatusOptions.${TaskStatusDto.New}`),
    value: TaskStatusDto.New,
  },
  {
    label: t(`taskStatusOptions.${TaskStatusDto.InProgress}`),
    value: TaskStatusDto.InProgress,
  },
  {
    label: t(`taskStatusOptions.${TaskStatusDto.DoneNotConfirmed}`),
    value: TaskStatusDto.DoneNotConfirmed,
  },
];

export const ContactDetailsTasks: React.FC<Props> = props => {
  const { contactId } = props;
  const { getResourceTasks } = useGetResourceTasks({ resourceId: String(contactId) });
  const { t: tasksT } = useTranslationWithPrefix('views.tasks.list.table.head');

  const resourceTypeOptions: SelectSearchOptionModel<ResourceTypeDto>[] = [
    {
      label: ResourceTypeDto.Contact,
      value: ResourceTypeDto.Contact,
    },
  ];
  const defaultStatuses: SelectSearchOptionModel<TaskStatusDto>[] = useMemo(
    () => defaultStatusesFn(tasksT),
    [tasksT],
  );

  return (
    <CustomerDetailsAccordion expanded>
      <TasksListTable
        customRow={ProcessDetailsTasksTableRow}
        initialParams={{
          contextResourceId: String(contactId),
          contextResourceTypes: resourceTypeOptions,
          taskStatuses: defaultStatuses,
        }}
        request={getResourceTasks}
        size="small"
        tableKey={`contact_details-${contactId}`}
        typeDefined
      />
    </CustomerDetailsAccordion>
  );
};
